import { ProposalOverviewViewModel } from 'bff';
import { ProposalCard } from 'modules/new-business/components/molecules/proposal-card/ProposalCard';
import styles from './mobile-view-proposal.module.scss';

type MobileCardViewProposalProps = {
  proposals: Array<ProposalOverviewViewModel> | undefined;
  search: string | undefined;
  disabled: boolean;
};

export const MobileViewProposals = ({ proposals, disabled }: MobileCardViewProposalProps) => {
  return (
    <div className={styles.proposalCardWrapper}>
      {proposals != undefined &&
        proposals.map((proposal, index) => (
          <ProposalCard key={index} proposal={proposal} disabled={disabled} />
        ))}
    </div>
  );
};
